import styled from 'styled-components';
import { colors } from '../colors';

interface paragraphProps {
	margin?: string;
	padding?: string;
	marginTop?: string;
	marginBottom?: string;
	marginLeft?: string;
	marginRight?: string;
	fontSize?: string;
	float?: string;
	width?: string;
	textAlign?: string;
	lineHeight?: string;
	display?: string;
	h1?: boolean;
	h2?: boolean;
	h3?: boolean;
	h4?: boolean;
	h5?: boolean;
	h6?: boolean;
	normal?: boolean;
	semiBold?: boolean;
	Bold?: boolean;
	headingNotes?: boolean;
	loginSubText?: boolean;
}
const Paragraph = styled.p<paragraphProps>`
	margin: 0px;
	white-space: nowrap;
    max-width: 100%;
    text-overflow: ellipsis;
	margin: ${({ margin }) => margin}!important;
	padding: ${({ padding }) => padding};
	margin-top: ${({ marginTop }) => marginTop}!important;
	margin-bottom: ${({ marginBottom }) => marginBottom}!important;
	margin-left: ${({ marginLeft }) => marginLeft}!important;
	margin-right: ${({ marginRight }) => marginRight}!important;
	font-size: ${({ fontSize }) => fontSize}!important;
	float: ${({ float }) => float}!important;
	width: ${({ width }) => width}!important;
	text-align: ${({ textAlign }) => textAlign}!important;
	line-height: ${({ lineHeight }) => lineHeight}!important;
	display: ${({ display }) => display}!important;
	cursor: auto;
	line-height: normal;
	${({ normal }) =>
		normal &&
		`font-family: 'RubikRegular'!important;
	`}
	${({ semiBold }) =>
		semiBold &&
		`font-family: 'RubikMedium'!important;
	`}
	${({ Bold }) =>
		Bold &&
		`font-family: 'RubikBold'!important;
	`}
	${({ h1 }) =>
		h1 &&
		`font-size: 26px;
	`}
	${({ h2 }) =>
		h2 &&
		`font-size: 22px;
	`}
	${({ h3 }) =>
		h3 &&
		`font-size: 18px;
	`}
	${({ h4 }) =>
		h4 &&
		`font-size: 16px;
	`}
	${({ h5 }) =>
		h5 &&
		`font-size: 14px;
	`}
	${({ h6 }) =>
		h6 &&
		`font-size: 12px;
	`}
	${({ headingNotes }) =>
		headingNotes &&
		`font-size: 12px;
		line-height: 14px;
		color: ${colors.Grey58};
		font-style: italic;
		white-space:normal!important;
	`}
	${({ loginSubText }) =>
		loginSubText &&
		`font-size: 18px;
		line-height: 20px;
		color:${colors.Grey53};
		margin-top:18px;
		white-space: normal;
		@media (max-width:992px){
			font-size: 14px;
		}
		@media (max-width:860px){
			margin-bottom:20px;
		}
	`}
`;

export default Paragraph;
